<template>
  <div class="section">
    <div class="container mb-2">
      <div class="row g-pt-100">
        <div class="col-md-5 mx-auto">
          <form @submit.prevent="logUser" autocomplete="off" class="my-4">
            <div class="features_axi_box active mt-3 rounded">
              <div
                class="alert fade show alert-danger px-1"
                role="alert"
                v-if="$route.query['request-origin'] === 'account-activation'"
              >
                <div class="d-flex">
                  <div class="col-2 my-auto">
                    <i
                      class="fa fa-check-circle h1 text-primary"
                      style="font-size: 2.5rem !important;"
                    ></i>
                  </div>
                  <div class="col">
                    <p>Your account has been activated successfully. Please log into your account now.</p>
                  </div>
                </div>
              </div>
              <div class="alert alert-danger" v-if="invalidLogin">
                <span>Invalid password or username</span>
              </div>
              <h4 class="mb-5 text-center">Log into your account</h4>
              <div class="form-group">
                <input
                  class="form-control"
                  name="Username"
                  v-validate="'required'"
                  type="text"
                  v-model="credentials.username"
                  placeholder="Email address"
                  :class="{'is-invalid': errors.has('Username')}"
                />
                <div class="invalid-feedback">{{ errors.first('Username') }}</div>
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  type="password"
                  v-validate="'required'"
                  name="password"
                  :class="{'is-invalid': errors.has('password')}"
                  placeholder="Your Password"
                  ref="password"
                  v-model="credentials.password"
                />

                <div class="invalid-feedback">{{ errors.first('password') }}</div>
              </div>
              <div class="d-flex flex-wrap justify-content-between padding-bottom-1x">
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" id="remember_me" checked />
                  <label class="custom-control-label" for="remember_me">Remember me</label>
                </div>
                <router-link :to="{ name:'resetpassword' }" class="nav-link">Forgot password?</router-link>
              </div>
              <div class="text-center text-sm-right">
                <button type="submit" class="btn btn-gradient text-uppercase btn-block">Sign in</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  props: {
    passwordReseted: {
      type: Boolean,
      default: false
    },
    billingRequest: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    credentials: {
      username: null,
      password: null
    },
    invalidLogin: false,
    loginSucceed: false
  }),
  methods: {
    logUser: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var formData = this.formData(this.credentials);
          this.$store
            .dispatch("logUser", formData)
            .then(response => {
              if (response.data.error) {
                this.invalidLogin = true;
                this.loginSucceed = false;
              } else {
                this.invalidLogin = false;
                this.loginSucceed = true;
                window.location.replace("/account");
              }
            })
            .catch(err => console.log(err));
        }
      });
    }
  }
};
</script>